import React from 'react';
import ImageCode from './ImageCode';
import WrapComponent from '../WrapComponent';

class FileIndex extends React.Component{
    render(){
        let {api_name, is_required, form} = this.props;
        const {getFieldProps} = form;
        let fieldProps = getFieldProps(api_name, {
            validate: [{
                rules:[{
                    required: is_required,
                    'message': $st('验证码是必填项')
                }, {validator(rule, value, callback){
                    if (!value || (value.verifyCode && value.verifyCode.length < 4)){
                        callback([$st('验证输入不正确!')]);
                    }else{
                        callback();
                    }
                }}]
            }]
        })

        return (
            <ImageCode {...this.props} {...fieldProps}></ImageCode>
        )
    }
    
}

export default WrapComponent(FileIndex);


// WEBPACK FOOTER //
// ./src/component/ImageCode/index.js